import './patientInformationDetailsComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import PatientInformationEditComponent from "./patient-information-edit/patientInformationEditComponent";
import PatientInformationViewComponent from "./patient-information-view/patientInformationViewComponent";

interface PatientInformationDetailsComponentProps {
    patientDetails: any;
    onUpdatePatientInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const PatientInformationDetailsComponent = (props: PatientInformationDetailsComponentProps) => {
        const {patientDetails, onUpdatePatientInformation,onModeChange,canEdit} = props;
        const [mode, setMode] = useState<"view" | "edit">("view");
        const [patientBasicInformation, setPatientBasicInformation] = useState<any>(undefined);

        const handlePatientBasicInformationUpdate = useCallback((updatedPatientInformation: any) => {
            onUpdatePatientInformation(updatedPatientInformation);
            setMode("view");
        }, [onUpdatePatientInformation]);

        const handlePatientBasicInformationEditCancel = useCallback(() => {
            setMode("view");
        }, []);

        useEffect(() => {
            if (patientDetails) {
                setPatientBasicInformation(patientDetails);
            }
        }, [patientDetails]);

        useEffect(()=>{
            onModeChange(mode)
        },[mode,onModeChange]);

        return (
            <div className="patient-information-component details-tab-data-wrapper">
                {
                    mode === "view" && <PatientInformationViewComponent
                        patientDetails={patientBasicInformation}
                        canEdit={canEdit}
                        onEditModeOpen={() => {
                            setMode("edit")
                        }}
                    />
                }
                {
                    mode === "edit" && <PatientInformationEditComponent patientDetails={patientBasicInformation}
                                                                        onUpdateComplete={handlePatientBasicInformationUpdate}
                                                                        onEditCancel={handlePatientBasicInformationEditCancel}
                    />
                }
            </div>
        )
    }

;

export default PatientInformationDetailsComponent;